module.exports = __webpack_public_path__ + "static/img/interactive-img2.0cf6115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/interactive-img2.jpg
// module id = 328
// module chunks = 64